"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var _require = require('./loggerFactory'),
    getFedOpsClientLogger = _require.getFedOpsClientLogger;

var _ = require('lodash');

var buildDefaultTagStore = function buildDefaultTagStore(editorModel, loggerModel) {
  return {
    publicUrl: _.get(editorModel, 'publicUrl'),
    numberOfPages: _.get(editorModel, 'siteHeader.pageIdList.pages.length'),
    revision: _.get(editorModel, 'siteHeader.revision'),
    geo: _.get(editorModel, 'geo'),
    metaSiteId: _.get(editorModel, 'metaSiteId'),
    isDesktopEditor: true,
    isMobileEditor: false,
    editorLoaded: false,
    isPreview: false,
    ds: loggerModel.origin
  };
};

var buildDefaultContext = function buildDefaultContext(editorModel) {
  return {
    previewUrl: _.get(editorModel, 'previewUrl'),
    runningExperiments: _.get(editorModel, 'runningExperiments'),
    isPublished: _.get(editorModel, 'siteHeader.published'),
    premiumFeatures: _.get(editorModel, 'metaSiteData.premiumFeatures')
  };
};

var getBiStore = function getBiStore(artefactModel) {
  return {
    metaSiteId: _.get(artefactModel, 'metaSiteId')
  };
};

var isWixCodeError = function isWixCodeError(data) {
  var exceptionFrames = _.get(data, ['exception', 'values', 0, 'stacktrace', 'frames'], []);

  return exceptionFrames.filter(function (frame) {
    return frame && _.isString(frame.filename);
  }).some(function (frame) {
    return frame.filename.includes('wixCode') || frame.filename.includes('wix-code');
  });
};

var missingSentryLogger = function missingSentryLogger(fedopsLogger, local) {
  return {
    error: console.error,
    enrichError: function enrichError()
    /*e, {tags, extra, fingerprint} = {}*/
    {},
    captureError: function captureError() {
      var _console;

      (_console = console).error.apply(_console, arguments);
    },
    setGlobalsForErrors: function setGlobalsForErrors()
    /*{tags, extras} = {}*/
    {},
    breadcrumb: function breadcrumb()
    /*messageContent, additionalData = {}*/
    {},
    interactionStarted: function interactionStarted(i) {
      return fedopsLogger.interactionStarted(i);
    },
    interactionEnded: function interactionEnded(i) {
      return fedopsLogger.interactionEnded(i);
    },
    appLoadingPhaseStart: function appLoadingPhaseStart(phase) {
      return fedopsLogger.appLoadingPhaseStart(phase);
    },
    appLoadingPhaseFinish: function appLoadingPhaseFinish(phase) {
      return fedopsLogger.appLoadingPhaseFinish(phase);
    },
    appLoaded: function appLoaded() {
      return fedopsLogger.appLoaded();
    },
    log: local ? console.log : function () {}
  };
};

var shouldFilter = function shouldFilter(url, message) {
  return url.includes('isqa=true') || url.includes('suppressbi=true') || message.includes('play() failed because the user didn\'t interact with the document first') || message.includes('The play() request was interrupted by a call to pause()');
};

var createLogger = function createLogger(_ref, sentryClient) {
  var local = _ref.local,
      loggerModel = _ref.loggerModel,
      editorModel = _ref.editorModel;
  var model = editorModel || {};
  var biStore = getBiStore(model);
  var fedopsLogger = getFedOpsClientLogger(_.defaults(loggerModel, biStore));

  if (!sentryClient) {
    return missingSentryLogger(fedopsLogger, local);
  }

  var currentRelease = _.get(model, 'editorVersion');

  sentryClient.configureScope(function (scope) {
    scope.addEventProcessor(function (event, hint) {
      var url = event.request.url;
      var _hint$originalExcepti = hint.originalException,
          message = _hint$originalExcepti.message,
          loggerParams = _hint$originalExcepti.loggerParams;

      if (shouldFilter(url, message)) {
        return null;
      }

      if (!local && currentRelease && currentRelease !== 'unknown') {
        event.environment = 'production';
        event.release = currentRelease;
      } else {
        event.environment = 'development';
      }

      var exceptionFrames = _.get(event, ['exception', 'values', 0, 'stacktrace', 'frames'], []);

      if (isWixCodeError(event)) {
        event.tags = _.assign(event.tags || {}, {
          'wix-code-error': true
        });
        event.fingerprint = _.concat(event.fingerprint || [], ['wix-code-error']);
      }

      if (_.has(event.tags, 'whiteScreenOfDeath')) {
        event.fingerprint = ['whiteScreenOfDeath'];
      } else if (exceptionFrames.length) {
        _.set(event, ['exception', 'values', 0, 'stacktrace', 'frames'], _.map(exceptionFrames, function (frame) {
          if (frame && _.isString(frame.filename)) {
            frame.abs_path = frame.filename;
            frame.filename = _.last(_.split(frame.filename, '/'));
          }

          return frame;
        }));

        var lastFrame = _.last(exceptionFrames);

        event.fingerprint = _.concat(event.fingerprint || [], [lastFrame.filename, lastFrame.lineno, lastFrame.colno]);
      }

      if (loggerParams) {
        if (event.extra && event.extra.TypeError) {
          delete event.extra.TypeError.loggerParams;
        }

        var tags = loggerParams.tags,
            extra = loggerParams.extra,
            fingerprint = loggerParams.fingerprint;

        if (tags) {
          event.tags = event.tags || {};
          Object.assign(event.tags, tags);
        }

        if (extra) {
          event.extra = event.extra || {};
          Object.assign(event.extra, extra);
        }

        if (fingerprint) {
          event.fingerprint = fingerprint;
        }
      }

      return event;
    });
    scope.setUser({
      id: _.get(model, 'permissionsInfo.loggedInUserId'),
      roles: _.get(model, 'permissionsInfo.loggedInUserRoles')
    });
  });

  var getSentry = function getSentry(forceLoad) {
    if (forceLoad) {
      sentryClient.forceLoad();
    }

    return sentryClient;
  };

  var logger = {
    enrichError: function enrichError(e) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          tags = _ref2.tags,
          extra = _ref2.extra,
          fingerprint = _ref2.fingerprint;

      e.loggerParams = {
        tags: tags,
        extra: extra,
        fingerprint: ['{{ default }}'].concat(_toConsumableArray(fingerprint))
      };
    },
    captureError: function captureError(e) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          tags = _ref3.tags,
          extras = _ref3.extras,
          _ref3$level = _ref3.level,
          level = _ref3$level === void 0 ? 'error' : _ref3$level,
          _ref3$groupErrorsBy = _ref3.groupErrorsBy,
          groupErrorsBy = _ref3$groupErrorsBy === void 0 ? 'tags' : _ref3$groupErrorsBy;

      return getSentry(true).withScope(function (scope) {
        var fingerprints = [];

        for (var key in tags) {
          if (tags.hasOwnProperty(key)) {
            scope.setTag(key, tags[key]);

            if (groupErrorsBy === 'tags') {
              fingerprints.push(key);
            } else if (groupErrorsBy === 'values') {
              fingerprints.push(tags[key]);
            }
          }
        }

        for (var _key in extras) {
          if (extras.hasOwnProperty(_key)) {
            scope.setExtra(_key, extras[_key]);
          }
        }

        scope.setLevel(level);

        if (fingerprints.length) {
          scope.setFingerprint([].concat(fingerprints));
        }

        getSentry().captureException(e);
        fedopsLogger.interactionStarted('error'); //this is a workaround to get error rate until we will have support for postgresSQL in fedonomy
      });
    },
    setGlobalsForErrors: function setGlobalsForErrors() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          tags = _ref4.tags,
          extra = _ref4.extra;

      return getSentry().configureScope(function (scope) {
        scope.addEventProcessor(function (event, hint) {
          var url = event.request.url;
          var message = hint.originalException.message;

          if (shouldFilter(url, message)) {
            return null;
          }

          if (tags) {
            event.tags = event.tags || {};
            Object.assign(event.tags, tags);
          }

          if (extra) {
            event.extra = event.extra || {};
            Object.assign(event.extra, extra);
          }

          return event;
        });
      });
    },
    breadcrumb: function breadcrumb(messageContent) {
      var additionalData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return getSentry().addBreadcrumb({
        message: messageContent,
        data: additionalData
      });
    },
    interactionStarted: function interactionStarted(i) {
      return fedopsLogger.interactionStarted(i);
    },
    interactionEnded: function interactionEnded(i) {
      return fedopsLogger.interactionEnded(i);
    },
    appLoadingPhaseStart: function appLoadingPhaseStart(phase) {
      return fedopsLogger.appLoadingPhaseStart(phase);
    },
    appLoadingPhaseFinish: function appLoadingPhaseFinish(phase) {
      return fedopsLogger.appLoadingPhaseFinish(phase);
    },
    appLoaded: function appLoaded() {
      return fedopsLogger.appLoaded();
    },
    log: local ? console.log : function () {}
  };
  logger.setGlobalsForErrors({
    tags: buildDefaultTagStore(model, loggerModel),
    extra: buildDefaultContext(model)
  });
  return logger;
};

module.exports = createLogger;
//# sourceMappingURL=logger.js.map